export default __webpack_public_path__ + "f17ec551fa8990736da1996972ea55f0.woff2";